import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import withAttr from 'flarum/common/utils/withAttr';
import Field from './Field';
import File from '../models/File';

const translationPrefix = 'kilowhat-formulaire.forum.upload-editor.';

export default class Upload extends Field {
    whiteListConfigProperties() {
        return super.whiteListConfigProperties().concat([
            'mime',
            'min',
            'max',
        ]);
    }

    configure() {
        return [
            m('.Form-group', m('.FormulaireInputWithLabel', {
                className: this.getConfig('mime') ? 'FormulaireInputWithLabel--with-value' : '',
            }, [
                m('input.FormControl', {
                    type: 'text',
                    value: this.getConfig('mime'),
                    onchange: withAttr('value', this.setConfig('mime')),
                    disabled: this.disabled,
                }),
                m('label', app.translator.trans('kilowhat-formulaire.forum.template-editor.mime')),
            ])),
            this.minMaxRules(),
        ];
    }

    fill() {
        const allowsMultiple = this.getConfig('max') !== 1;

        const existingFiles = this.getSubmission([]);

        return [
            m('ul', existingFiles.map((id: string) => {
                const file = app.store.getById<File>('formulaire-files', id);

                return m('li', [
                    file ? m('a', {
                        href: file.url(),
                        download: file.filename(),
                    }, [
                        file.filename(),
                        file.humanSize() ? [' (', file.humanSize(), ')'] : null,
                    ]) : id,
                    ' ',
                    existingFiles.length > this.getConfig('min') ? Button.component({
                        onclick: () => {
                            this.setSubmission(this.getSubmission([]).filter((thisId: string) => thisId !== id));
                        },
                        className: 'Button Button--icon',
                        icon: 'fas fa-trash',
                        disabled: this.isFillDisabled(),
                        title: app.translator.trans(translationPrefix + 'remove'),
                    }) : null,
                ]);
            })),
            this.uploader?.uploading ? app.translator.trans(translationPrefix + 'uploading') : null,
            m('input', {
                type: 'file',
                id: this.uniqueFieldId(),
                onchange: (event: Event) => {
                    this.uploader?.upload((event.target as HTMLInputElement).files, this.getConfig('key')).then(files => {
                        let submission = JSON.parse(JSON.stringify(this.getSubmission([])));

                        if (allowsMultiple) {
                            files.forEach(file => {
                                submission.push(file.id());
                            });
                        } else {
                            // If multiple is now allowed, replace current file(s) with new file(s) (there should be only 1)
                            submission = files.map(file => file.id());
                        }

                        this.setSubmission(submission);

                        m.redraw();
                    });
                },
                disabled: this.isFillDisabled(),
                accept: this.getConfig('mime'),
                multiple: allowsMultiple,
            }),
        ];
    }

    display() {
        const existingFiles = this.getSubmission([]);

        return [
            m('ul', existingFiles.map((id: string) => {
                const file = app.store.getById<File>('formulaire-files', id);

                return m('li', [
                    file ? m('a', {
                        href: file.url(),
                        download: file.filename(),
                    }, [
                        file.filename(),
                        file.humanSize() ? [' (', file.humanSize(), ')'] : null,
                    ]) : id,
                ]);
            })),
        ];
    }
}
